(function ($) {

  /* CONSUMER: BEFORE AND AFTER CALLOUT/PAGE */
  $('#before-after-slides .tab-item a').on('click', function (e) {
    e.preventDefault();
    var tab = $(this).data('tab');
    $('#before-after-slides .media-wrapper').removeClass('active');
    $('#before-after-slides .media-wrapper.' + tab ).addClass('active');

    $('#before-after-slides .info-wrapper .info').removeClass('active');
    $('#before-after-slides .info-wrapper .info.' + tab).addClass('active');

    $('#before-after-slides .tab-item a').removeClass('active');
    $(this).addClass('active');
  });

  /* FIND A PROVIDER CALLOUT */
  $('.find-a-provider-callout button').on('click', function (e) {
    e.preventDefault();
    window.location = '/encuentratudoctor';
  });

  /* READMORE / READLESS */
  $('.btn-readmore').on('click', function() {
    var circle = $(this).children('.circle');
    if (circle.length > 0) {
      var text_el = circle.next('span'); // Might or might not exist
      if (circle.hasClass('plus')) {
        circle.removeClass('plus').addClass('minus');
        if (text_el.length > 0) {
          text_el.text('Leer menos');
        }
      }
      else {
        circle.removeClass('minus').addClass('plus');
        if (text_el.length > 0) {
          text_el.text('Leer más');
        }
      }
    }
  });

  /* REVIEWS/MEDIA/VIDEO SWAP */

  // Smaller things you're supposed to click on to show a bigger one
  $('.nonvideo-teaser').on('click', function() {
    // visual feedback
    $('.nonvideo-teaser').removeClass('active');
    $(this).addClass('active');
    // nonvideo-[item->ID]
    var id = $(this).data('id');
    if (length === false) {
      return false;
    }
    var container_id = 'nonvideo-full-' + id;
    // remove all, then target the current one
    $('.nonvideo-full').removeClass('active');
    $('#' + container_id).addClass('active');
  });

  /* MOBILE MENU / OFFCANVAS MENU */
  $('[data-toggle="offcanvas"], #navToggle').on('click', function () {
    $('.navbar-offcanvas').toggleClass('open');
  });

  /* ACTIVE STATES for MOBILE MENU */
  $('.nav-option').on('click', function(e) {
    if ($(this).hasClass('menu-item-has-children')) {
      e.preventDefault();
      var child = $(this).next('.nav-child');
      if (!$(this).hasClass('active')) {
        $(this).addClass('active');
        child.addClass('active');
        $(this).find('.arrow').removeClass('down').addClass('up');
      }
      else {
        $(this).removeClass('active');
        child.removeClass('active');
        $(this).find('.arrow').removeClass('up').addClass('down');
      }
    }
  });

  /* SHOW MORE / SHOW LESS (media page-s) */
  var x = 3;
  $('#news-tabs-content .tab-pane ul').each(function() {
    $(this).children('li:lt('+ x +')').slideDown();
  });
  $('#events-tabs-content .tab-pane ul').each(function() {
    $(this).children('li:lt('+ x +')').slideDown();
  });
  $('#load-more-news').click(function () {
    var active = $('#news-tabs-content .tab-pane.active');
    if (active.length === 1) {
      var active_id = active[0].id;
      var n = $('#' + active_id + ' li').length;
      x = ( x + 3 <= n) ? x + 3 : n;
      $('#' + active_id + ' li:lt('+ x +')').slideDown();
      if (x === n) {
        $('#load-more-news').hide();
      }
    }
  });
  $('#load-more-events').click(function () {
    var active = $('#events-tabs-content .tab-pane.active');
    if (active.length === 1) {
      var active_id = active[0].id;
      var n = $('#' + active_id + ' li').length;
      x = ( x + 3 <= n) ? x + 3 : n;
      $('#' + active_id + ' li:lt('+ x +')').slideDown();
      if (x === n) {
        $('#load-more-events').hide();
      }
    }
  });

  $('.nav-tabs .nav-item.disabled a').each(function() {
    $(this).css('text-decoration', 'none').click(function(e) {
      e.preventDefault();
      return false;
    });
  });

  /* BOOTSTRAP CLASSES ADDED TO DESKTOP MENU (now with fun CSS icon arrows!)  */
  $('#navbar-desktop .primary-nav ul li.menu-item-has-children').each(function() {
    $(this).addClass('dropdown');
    $(this).children('a')
      .append('<i class="arrow down"></i>')
      .attr({
        'data-toggle': 'dropdown',
        'role': 'button',
        'aria-haspopup': 'true',
        'aria-expanded': 'false'
      })
      .next('ul').addClass('dropdown-menu')
      .children('li').addClass('dropdown-item');
  });

  /* BOOTSTRAP MODAL DIALOG HELPER(S) */

  // Basic usage is to add data attributes on anchor like:
  //    data-toggle="modal" data-target="#modal-optin-physicians"
  //    but if we want to trigger it from a WordPress nav link
  //    we have to add a css class called 'toggle-modal' in the WP nav menu
  //    but that will be on the 'li' element, but will let us delegate
  //    to the anchor with a little bit of custom javascript, below.
  //    The href attribute will be a fragment link of the modal's id tag...
  var toggle_modal = $('.toggle-modal');
  if (toggle_modal.length) {
    if ( !toggle_modal.is('a') ) {
      // if it's on a list element, like a wp menu nav item, a is the child
      toggle_modal = toggle_modal.children('a');
      toggle_modal.attr('data-toggle', 'modal').attr('data-modal', toggle_modal.attr('href'));
    }
  }

  // assume modal link is the element itself, like an image
  $('.open-modal').click(function(e) {
    e.preventDefault();
    var el = {};
    var caption = $(this).attr('title');

    // different data attributes do different things
    var iframe = $(this).data('iframe');
    var modal = $(this).data('modal');

    var classes = [];
    if (typeof iframe !== 'undefined') {
      if (iframe === 'video') {
        classes.push('modal-video');
      }
      var str = '';
      str += '<iframe src="' + $(this).attr('href') + '"';
      str += 'style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" scrolling="no">';
      str += '</iframe>';
      el = $(str);
      // do something when you close the modal
      $('#modal-generic').on('hidden.bs.modal',function() {
        // a video might still be playing, just get rid of it...
        $('#modal-generic .modal-body').html('');
      });
    }
    else if (typeof modal !== 'undefined') {
      // link will open up existing div with the data value == id (without #)
      classes.push('modal-' + modal);
      el = $('#' + modal);
    }
    else {
      el = $(this).clone().removeClass('open-modal');
    }
    // we should have something to add to the modal body at this point
    if (el.length > 0) {
      $('#modal-generic .modal-body').html(el);
      $('#modal-generic .modal-title').text('');
      if (typeof caption !== 'undefined' && caption.length > 0) {
        $('#modal-generic .modal-title').text(caption);
      }
      var str = classes.join(' ');
      $('#modal-generic').addClass(str).modal('show');
    }
  });

  /* CONTACT FORM 7: Validation Events for changing response CSS classes to Bootsrap classes */
  document.addEventListener( 'wpcf7invalid', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-danger');
  }, false );
  document.addEventListener( 'wpcf7spam', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-warning');
  }, false );
  document.addEventListener( 'wpcf7mailfailed', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-warning');
  }, false );
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    $('.wpcf7-response-output').addClass('alert alert-success');
    if ($('.wpcf7-mail-sent-ok-custom').length > 0) {
      $(event.target).hide().closest('.modal').find('.wpcf7-mail-sent-ok-custom').show();
    }
    //dataLayer.push({'event': 'formSubmit', 'formId': 'Sign Up for Email Submit'}); //google tag manager
    //fbq('track', 'CompleteRegistration'); //facebook pixel

    // @todo: combine the functionality above which essentially does same thing as code below.
    // Ultherapy Concierge...
    if ($('#concierge-wrapper').length > 0) {
      $('#concierge-wrapper').hide();
      $('#concierge-thankyou').show();
      $('html, body').animate({scrollTop: $('#concierge-thankyou').offset().top}, 1000);
    }
  }, false );

  /* CONTACT FORM 7: FIX for ignoring wpautop removal...? */
  $('.wpcf7-form p').filter(function () { return $.trim(this.innerHTML) == "" }).remove();
  $('.wpcf7-form label br').remove();

  /* GLOBAL: MISCELLANEA */

  // Button scroll to anchor
  $('.btn[href^="#"').on('click', function(e) {
    e.preventDefault();
    var id = $(this).attr('href');
    if (id.length > 0) {
      $('html, body').animate({
        scrollTop: $(id).offset().top - 25
      }, 800);
    }
  });   

  // Make sure certain links don't work.  Ok then.
  $('a.unlink').on('click', function(e) {
    e.preventDefault();
  });    

}(jQuery));
